import axios from 'axios';
import { getActiveStoreId, getApiBaseUrl } from '../lib/storefront/storeBootstrap';

const API_URL = getApiBaseUrl();

/** Public store profile: contact details, opening hours, socials, currency, locale. */
export const fetchPublicSettings = async (storeId = getActiveStoreId()) => {
    try {
        const headers = storeId ? { 'X-Store-Id': storeId } : undefined;
        const response = await axios.get(`${API_URL}/api/settings/public`, { headers });
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
